import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import APP_BASE_URL from "../../components/Api/globalApi";
import { ThreeDots } from "react-loader-spinner";
import { FaSearch } from "react-icons/fa";

const Incomewallethis = () => {
  const [userhistory, setUserhistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [userlogin, setUserlogin] = useState(null);
  const [query, setQuery] = useState("");

  useEffect(() => {
    fetchUserHistory();
  }, []);

  const fetchUserHistory = async () => {
    try {
      const response = await axios.post(
        ` ${APP_BASE_URL}/admin/upi/transaction/list`
      );
      setUserhistory(response.data.list);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError("Error fetching data. Please try again.");
      console.error("Error fetching user history:", error);
    }
  };

  const Activation = async (ut_id, newStatus) => {
    setUserlogin(ut_id);
    try {
      const response = await axios.post(
        `${APP_BASE_URL}/admin/upi/transaction/approve`,
        { ut_id: ut_id, status: newStatus }
      );

      if (response.data.result === true) {
        alert("Approval Successful");
        fetchUserHistory();
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.error("Error approving user:", error);
    } finally {
      setUserlogin(null);
    }
  };

  const handleImageClick = (imagePath) => {
    setSelectedImage(`https://api.springwayhub.com/${imagePath}`);
    setShowModal(true);
  };

  // Filter user history based on the query
  const filteredUserHistory = userhistory.filter((details) =>
    details.u_referal_id.toLowerCase().includes(query)
  );

  return (
    <div className="container-fluid myprofile py-5">
      {loading ? (
        <div className="mt-5">
          <ThreeDots color="#00BFFF" height={20} width={50} />
        </div>
      ) : error ? (
        <div>{error}</div>
      ) : (
        <>
          <div className="search-box mb-3">
            <FaSearch id="search-icon" />
            <input
              id="search"
              type="text"
              placeholder="Search by referral ID"
              value={query}
              onChange={(e) => setQuery(e.target.value.toLowerCase())}
            />
          </div>

          <div className="table-responsive">
            <table className="table table-light table-hover shadow">
              <thead>
                <tr>
                  <th scope="col">Sl no</th>
                  <th scope="col">Transaction Id</th>
                  <th scope="col">Amount</th>
                  <th scope="col">Referral Id</th>
                  <th scope="col">Payment slip</th>
                  <th scope="col">Activation</th>
                </tr>
              </thead>
              <tbody>
                {filteredUserHistory.length > 0 ? (
                  filteredUserHistory.map((details, index) => (
                    <tr key={index}>
                      <th scope="row">{index + 1}</th>
                      <td>{details.ut_utr_no}</td>
                      <td>{details.ut_amount}</td>
                      <td>{details.u_referal_id}</td>
                      <td>
                        <img
                          src={`https://api.springwayhub.com/${details.ut_payment_slip}`}
                          alt="Payment Slip"
                          style={{
                            cursor: "pointer",
                            width: "50px",
                            height: "50px",
                          }}
                          onClick={() =>
                            handleImageClick(details.ut_payment_slip)
                          }
                        />
                      </td>
                      <td className="text-capitalize">
                        {details.ut_status === "pending" ? (
                          <span>
                            <Button
                              onClick={() =>
                                Activation(details.ut_id, "approved")
                              }
                              className="bg-success text-capitalize text-white me-2 mb-2"
                              disabled={userlogin === details.ut_id}
                            >
                              {userlogin === details.ut_id ? (
                                <ThreeDots
                                  color="#00BFFF"
                                  height={20}
                                  width={50}
                                />
                              ) : (
                                "Approve"
                              )}
                            </Button>
                            <Button
                              onClick={() =>
                                Activation(details.ut_id, "rejected")
                              }
                              className="bg-danger text-capitalize text-white"
                              disabled={userlogin === details.ut_id}
                            >
                              Reject
                            </Button>
                          </span>
                        ) : (
                          <Button
                            className={`${details.ut_status === "approved"
                                ? "bg-success text-capitalize"
                                : "bg-danger text-capitalize"
                              } text-white`}
                            disabled
                          >
                            {details.ut_status}
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Payment Slip</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedImage && (
            <img src={selectedImage} alt="Payment Slip" className="img-fluid" />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Incomewallethis;
